import axios from 'axios';
import moment from 'moment';

export async function getServerDate() {
  const res = await axios.get('system');
  return moment.utc(res.data).toJSON() ?? moment().toJSON();
}
